import { Button } from "reactstrap"

const WorkspaceTabNav = ({ tabs, activeTab, onChange }) => (
  <div className="d-flex flex-wrap gap-2">
    {tabs.map(tab => {
      const isActive = tab.id === activeTab
      return (
        <Button
          key={tab.id}
          color={isActive ? "primary" : "light"}
          className={`rounded-pill px-3 py-2 ${isActive ? "shadow-sm" : ""}`}
          onClick={() => onChange(tab.id)}
        >
          <i className={`${tab.icon} me-2`} />
          {tab.label}
        </Button>
      )
    })}
  </div>
)

export default WorkspaceTabNav
